// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__3a4I5"};